import * as service from './OrganizationDetails.service.js'

export default {
  data() {
    return {
      Certificationcolumns: ['Name', 'Description', 'Actions'],
      optionstable: {

        headings: {
          Name: 'Name',
          Description: 'Description',
          edit: 'Edit',
          delete: 'Delete'

        },
        sortIcon: {
          base: 'glyphicon',
          up: 'glyphicon-chevron-up',
          down: 'glyphicon-chevron-down'
        },
        sortable: ['Name', 'Description'],
        texts: {

          filterPlaceholder: 'Search...',
          limit: 'Records:',
          noResults: 'No matching records',

        }

      },
      CertificationTypes: [],
      AddCertificateForm: {

        Name: '',
        Description: ''
      },
      IsCertificateTypeEdit: false,
      CertificateTypeEditID: 0,
      organizationDetails: {},
      locations: [],
      pools: [],
      locationName: '',
      poolName: '',
      selectedlocationId: '',
      selectedpoolId: '',
      editLocation: false,
      editPool: false,
      currentLocationName: '',
      currentPoolName: '',
      act: false,
      poolpromptVisible: false,
      locationpromptVisible: false,
      positionpromptVisible: false,

      organizationName: '',
      locationFlag: false,
      orgEditorgEdit: false,
      tabName: 'first',
      position: '',
      positions: [],
      //FG - FOOF - After Cert - First Release Security - below
      deliveredPositions: ['Aquatics Director','Pool Manager', 'Assistant Pool Manager','Head Lifeguard','Lifeguard','Office Staff','Pool Manager'],
      newlyAddedPositions: [], 
      //FG - FOOF - After Cert - First Release Security - above
      roles: [],
      editPosition: false,
      selectedpositionId: '',
      currentPositionName: '',
      roleModel: '',
      modalTitle: '',
      options: [{
        value: 'PDT',
        label: 'PDT'
      }, {
        value: 'MDT',
        label: 'MDT'
      }, {
        value: 'CDT',
        label: 'CDT'
      }, {
        value: 'EDT',
        label: 'EDT'
      }],
      Timezone: '',
      Timezoneselected: ''
    }
  },

  mounted() {

    this.organizationDetails = {
      organizationId: authDetails.OrganizationId,
      organizationName: authDetails.OrganizationName
    }
    this.getLocations()
    this.getPositions()
    this.getRoles()
    this.GetCertificationTypes()
  },

  methods: {
    showcertificate() {

      let context = this
      this.modalTitle = 'Create Certificate'
      $('#AddCertificatemodel').modal('show')

      setTimeout(function () {
        context.$refs['AddCertificateForm'].resetFields()
      }, 10)
    },

    del: function (data) {

      var ID = data.row.Id

      let context = this
      context.$confirm('Are you sure you want to delete?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {

        loader.startLoader()
        service.DeleteCertificationType(ID).then(function (response) {

          context.GetCertificationTypes()

          loader.stopLoader()

          context.$notify({
            title: 'Success',
            message: 'Deleted Successfully',
            type: 'success'
          })

        }, (error) => {

          loader.stopLoader()

          this.$notify({

            title: 'Error',

            message: error.responseJSON.Message,

            type: 'error'

          })
        })
        // context.$message({
        //   type: 'success',
        //   message: 'Delete completed'
        // });
      }).catch(() => {

      })

    },

    cancelpopup: function () {
      this.IsCertificateTypeEdit = false
      $('#AddCertificatemodel').modal('hide')
    },

    EditCertificateType: function (data) {
      let context = this
      var ID = this.CertificateTypeEditID
      if (ID !== 0) {
        let model = {
          Id: ID,
          Name: data.Name,
          Description: data.Description
        }
        loader.startLoader()
        service.UpdateCertificationType(model).then(function (response) {
          context.IsCertificateTypeEdit = false
          $('#AddCertificatemodel').modal('hide')
          context.CertificateTypeEditID = 0

          context.$notify({
            title: 'Success',
            message: 'Updated certificate type succesfully',
            type: 'success'
          })

          for (var i = 0; i < context.CertificationTypes.length; i++) {
            if (context.CertificationTypes[i].Id == ID) {

              context.CertificationTypes[i].Name = data.Name

              context.CertificationTypes[i].Description = data.Description
              break
            }
          }

          loader.stopLoader()

        }, (error) => {

          loader.stopLoader()

          this.$notify({

            title: 'Error',

            message: error.responseJSON.Message,

            type: 'error'

          })
        })

      }


    },

    editcol: function (data) {

      var ID = data.row.Id

      let context = this
      this.modalTitle = 'Edit Certificate'
      context.CertificateTypeEditID = ID
      for (var i = 0; i < context.CertificationTypes.length; i++) {
        if (context.CertificationTypes[i].Id == data.row.Id) {
          context.AddCertificateForm.Name = data.row.Name

          context.AddCertificateForm.Description = data.row.Description
          break
        }
      }
      context.IsCertificateTypeEdit = true

      $('#AddCertificatemodel').modal('show')

    },

    GetCertificationTypes() {
      let context = this
      loader.startLoader()
      service.GetCertificationTypes().then(function (response) {

        context.CertificationTypes = response
        loader.stopLoader()

      }, (error) => {

        loader.stopLoader()

        this.$notify({

          title: 'Error',

          message: error.responseJSON.Message,

          type: 'error'

        })
      })

    },

    submitForm(formName) {


      this.$refs[formName].validate((valid) => {


        if (valid) {

          let context = this
          loader.startLoader()

          let Model = {
            Name: context.AddCertificateForm.Name,
            Description: context.AddCertificateForm.Description
          }

          service.AddCertificationType(Model).then(function (response) {

            loader.stopLoader()
            $('#AddCertificatemodel').modal('hide')
            context.GetCertificationTypes()

          }, (error) => {

            loader.stopLoader()
            $('#AddCertificatemodel').modal('hide')
            this.$notify({

              title: 'Error',

              message: error.responseJSON.Message,

              type: 'error'

            })
          })

        } else {
          this.$notify({

            title: 'Error',

            message: 'POSITIONS - error while submit!!',

            type: 'error'

          })
          return false
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    checkSpace() {

      if (this.organizationName) {
        this.organizationName = this.organizationName.replace(/^\s+|\s+$/g, '')

      }

      if (this.locationName) {
        this.locationName = this.locationName.replace(/^\s+|\s+$/g, '')
      }
      if (this.currentLocationName) {
        this.currentLocationName = this.currentLocationName.replace(/^\s+|\s+$/g, '')
      }
      if (this.poolName) {
        this.poolName = this.poolName.replace(/^\s+|\s+$/g, '')
      }
      if (this.currentPoolName) {
        this.currentPoolName = this.currentPoolName.replace(/^\s+|\s+$/g, '')
      }
      if (this.position) {
        this.position = this.position.replace(/^\s+|\s+$/g, '')
      }
      if (this.currentPositionName) {
        this.currentPositionName = this.currentPositionName.replace(/^\s+|\s+$/g, '')
      }
    },

    UpdateOrganization() {
      let context = this
      loader.startLoader()
      service.UpdateOrganization({
        OrganizationId: authDetails.OrganizationId,
        OrganizationName: this.organizationName
      }).then(function (response) {
        authDetails.OrganizationName = context.organizationName
        context.organizationDetails.organizationName = context.organizationName
        context.$localStorage.set('authentication', JSON.stringify(authDetails))
        context.orgEditorgEdit = false
        loader.stopLoader()

      }, (error) => {

        loader.stopLoader()

        this.$notify({

          title: 'Error',

          message: error.responseJSON.Message,

          type: 'error'

        })
      })

    },
    //FG - FOOF - After Cert - First Release (6) - rewrote delete code below to use new methods in hydrowareCommonJS.js
    //The delete function below deletes a row from the table
    DeletePosition(item){
      let context = this
      var ID = item.row.PositionId
      var opts = {message: 'Are you sure you want to delete ' + item.row.PositionName + '?'}
      context.$hydrowareCommonJS.displayConfirmDeletePopup(context, opts, context.deletePositionRow.bind(null,ID))
    },
    deletePositionRow(ID) {
      var context = this;
      loader.startLoader()
      service.DeletePosition(ID).then(function (response) {

        //Is this restricted ? -- FG - After Cert - First Release Security
        if(context.$hydrowareCommonJS.displayHydrowareRestrictedMessageIfApplicable(response,context,{})) {   
          loader.stopLoader()
          return;
        }

        for (var i = 0; i < context.positions.length; i++) {
          if (context.positions[i].PositionId == ID) {
            context.positions.splice(i, 1)
            i--
          }
        }
        context.$hydrowareCommonJS.notifyDeleteSuccess(context);
        loader.stopLoader()

      }, 
      (error) => {
        loader.stopLoader()
        //context.$hydrowareCommonJS.notifyError(context,{message: error.responseJSON.Message})
        var opts = {message: error.responseJSON.Message}
        context.$hydrowareCommonJS.displayPopupNoDelete(this,opts)
      })
    },

    updateRole(positionId, roleId, positionName) {
      let context = this

      let positionModel = {
        PositionId: positionId,
        RoleId: roleId,
        PositionName: positionName

      }
      let cfinish = false
      let i = 0

      let resTime = setInterval(function () {
        i = i++

          if (i > 10 && !cfinish) {
            loader.startLoader()
            clearInterval(resTime)
          }

      }, 10)

      service.updateRole(positionModel).then(function (response) {

        //Is this restricted ? -- FG - After Cert - First Release Security
        if(context.$hydrowareCommonJS.displayHydrowareRestrictedMessageIfApplicable(response,context,{})) {   
          loader.stopLoader()
          return;
        }

        cfinish = true
        clearInterval(resTime)

        for (var i = 0; i < context.positions.length; i++) {

          if (context.positions[i].PositionId == positionId) {
            context.positions[i].PositionName = positionName
            context.currentPositionName = positionName
            context.selectedpositionId = ''
            context.editPosition = false
          }
        }

        loader.stopLoader()

      }, (error) => {
        cfinish = true
        clearInterval(resTime)
        loader.stopLoader()
        context.currentPositionName = positionName
        this.$notify({

          title: 'Error',

          message: error.responseJSON.Message,

          type: 'error'

        })
      })
    },

    //FG - FOOF - After Cert - First Release - added code below
    doesPositionAlreadyExist(aPositionName) {
        //If the position name is one of those delivered with Hydroware
        //then isDelivered will be a text message otherwise it will be null
        var isDelivered = this.isADeliveredPosition(aPositionName);
        if(isDelivered != null) return isDelivered;

        //Is this a newly added position ?
        var isNew = this.isNewlyAddedPosition(aPositionName)
        if(isNew != null) return isNew;

        //The position is not one that was delivered with our application
        //nor was it added while this window was currently being used
        //so we check to see if it is the list of all of the positions that
        //were returned from the database (these don't include any that have
        //been added while currently on this page)
        for(var i=0;i<this.positions.length;i++) {
          if(this.positions[i].PositionName == aPositionName) {
            return "It already exists.";
          }
        }        
    },
    isADeliveredPosition(aPositionName) {
      for(var i=0;i<this.deliveredPositions.length;i++) {
        if(this.deliveredPositions[i] == aPositionName)
        return "It is delivered with Hydroware.";
      }
      return null;
    },
    isNewlyAddedPosition(aPositionName) {
      for(var i=0;i<this.newlyAddedPositions.length;i++) {
        if(this.newlyAddedPositions[i] == aPositionName)
        return "It is newly added.";
      }
      return null;
    },
    shouldEditingBeDisabled(aPositionName) {
      //If aPositionName is in the newly added list then the user that just added it
      //must be able to choose a role for that position.
      //Lines below will return false if the name is newly added otherwise 
      //we continue thru the code.
      var isNewlyAddedMsg = this.isNewlyAddedPosition(aPositionName);
      if(isNewlyAddedMsg != null) return false;

      //If the user is trying to edit then disable if they do not permission to edit
      //UNLESS the position is newly added (taken care of just above)
      //Line below returns true if the selection drop down should be disabled because
      //the user does not permission to edit what was already in place otherwise
      //we continue thru the code
      var canEdit = this.$hydrowareSecurityJS.canEdit_A('positions');
      if(canEdit==false) return true;

      //If aPositionName is one of the positions delivered with Hydroware then the
      //user cannot change the role associated with it so we disable the select drop down
      var isDelivered = this.isADeliveredPosition(aPositionName)
      if(isDelivered != null) return true;
    },
    //FG - FOOF - After Cert - First Release - added code above

    addPosition() {

      //FG - FOOF - After Cert - First Release Security - don't allow duplicate position names
      //ADDED CODE BELOW
      var rtnFrom_doesPositionAlreadyExist = this.doesPositionAlreadyExist(this.position)
      if(rtnFrom_doesPositionAlreadyExist != null) { 
        var msg = "Cannot add " + this.position + ": " + rtnFrom_doesPositionAlreadyExist;     
        this.$hydrowareCommonJS.displayPopupMessage(this,{message:msg}) 
        return;
      }
      //ADDED CODE ABOVE

      let context = this    
      loader.startLoader()
      let positionModel = {
        PositionName: this.position
      }

      service.AddPosition(positionModel).then(function (response) {


        //Is this restricted ? -- FG - After Cert - First Release Security
        if(context.$hydrowareCommonJS.displayHydrowareRestrictedMessageIfApplicable(response,context,{})) {   
          loader.stopLoader()
          return;
        }

        if (!context.positions) {
          context.positions = []
        }

        context.positions.push({
          PositionId: response[0].PositionId,
          PositionName: context.position,
          RoleId: response[0].RoleId,
          RoleName: response[0].RoleName
        })

        //FG - FOOF - After Cert - First Release Security
        //  keep track of the positions that are newly added
        //  so we can allow those with permission to add to
        //  change the role associated with the new position.
        if(!context.newlyAddedPositions) {
          context.newlyAddedPositions =[]
        }
        context.newlyAddedPositions.push(context.position);

        context.position = ''
        loader.stopLoader()

      }, (error) => {

        loader.stopLoader()

        this.$notify({

          title: 'Error',

          message: error.responseJSON.Message,

          type: 'error'

        })
      })
    },
    getLocations() {
      let context = this
      loader.startLoader()
      service.GetLocations().then(function (response) {

        context.locations = response
        if (response) {
          if (response.length > 0) {
            setTimeout(function () {

              context.$refs.locationTable.setCurrentRow(context.locations[0])

            }, 500)

            context.getPools(response[0].LocationId)
            context.selectedlocationId = response[0].LocationId
            context.currentLocationName = response[0].LocationName
          }
        }

        loader.stopLoader()

      }, (error) => {

        loader.stopLoader()

        this.$notify({

          title: 'Error',

          message: error.responseJSON.error_description,

          type: 'error'

        })
      })

    },
    getPositions() {
      let context = this
      loader.startLoader()
      service.GetPositions().then(function (response) {
        
        //Is this restricted ? -- FG - After Cert - First Release Security
        if(context.$hydrowareCommonJS.displayHydrowareRestrictedMessageIfApplicable(response,context,{})) {   
          context.positions = []
          loader.stopLoader()
          return;
        }

        context.positions = response

        loader.stopLoader()

      }, (error) => {

        loader.stopLoader()

        this.$notify({

          title: 'Error',

          message: error.responseJSON.error_description,

          type: 'error'

        })
      })

    },
    getRoles() {
      let context = this
      loader.startLoader()
      service.GetRoles().then(function (response) {

        //Is this restricted ? -- FG - After Cert - First Release Security
        if(context.$hydrowareCommonJS.displayHydrowareRestrictedMessageIfApplicable(response,context,{})) {   
          context.roles = []
          loader.stopLoader()
          return;
        }

        window.xt = JSON.stringify(response)

        context.roles = response

        loader.stopLoader()

      }, (error) => {

        loader.stopLoader()

        this.$notify({

          title: 'Error',

          message: error.responseJSON.error_description,

          type: 'error'

        })
      })

    },
    getPools(locationId) {
      this.poolName = ''
      let context = this
      let cfinish = false
      let i = 0

      let resTime = setInterval(function () {
        i = i++

          if (i > 10 && !cfinish) {
            loader.startLoader()
            clearInterval(resTime)
          }

      }, 10)

      service.GetPoolsById(locationId).then(function (response) {
        cfinish = true
        context.pools = response
        clearInterval(resTime)
        if (response) {
          if (response.length > 0) {

            context.selectedpoolId = response[0].PoolId
            context.currentPoolName = response[0].PoolName
          }
        }

        loader.stopLoader()

      }, (error) => {
        cfinish = true
        clearInterval(resTime)
        loader.stopLoader()

        this.$notify({

          title: 'Error',

          message: error.responseJSON.error_description,

          type: 'error'

        })
      })

    },
    addPool() {
      let context = this
      loader.startLoader()

      service.AddPool({
        PoolName: this.poolName,
        LocationId: this.selectedlocationId
      }).then(function (response) {

        if (!context.pools) {
          context.pools = []
        }
        context.pools.push({
          PoolId: response.PoolId,
          PoolName: context.poolName
        })
        context.$router.app.$emit('invokePoolLoc')

        context.poolName = ''

        loader.stopLoader()

      }, (error) => {

        loader.stopLoader()

        this.$notify({

          title: 'Error',

          message: error.responseJSON.Message,

          type: 'error'

        })
      })
    },
    UpdatePool(poolid, poolname) {

      let context = this

      loader.startLoader()
      service.UpdatePool({
        PoolId: poolid,
        PoolName: poolname,
        LocationId: this.selectedlocationId
      }).then(function (response) {
        context.editPool = false
        context.$router.app.$emit('invokePoolLoc')
        for (var i = 0; i < context.pools.length; i++) {

          if (context.pools[i].PoolId == poolid) {
            context.pools[i].PoolName = poolname
            context.currentPoolName = poolname
          }
        }

        loader.stopLoader()

      }, (error) => {

        loader.stopLoader()
        context.currentPoolName = poolname
        this.$notify({

          title: 'Error',

          message: error.responseJSON.Message,

          type: 'error'

        })
      })

    },
    DeletePool(poolid) {
      let context = this

      this.$confirm('This will permanently delete the pool. Continue?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning',

      }).then(() => {

        loader.startLoader()

        service.DeletePool(poolid).then(function (response) {

          context.$router.app.$emit('invokePoolLoc')
          for (var i = 0; i < context.pools.length; i++) {

            if (context.pools[i].PoolId == poolid) {
              context.pools.splice(i, 1)
              i--
            }
          }

          context.$notify({

            title: 'Success',

            message: 'Pool deleted',

            type: 'success'

          })

          loader.stopLoader()

        }, (error) => {

          loader.stopLoader()

          this.$notify({

            title: 'Error',

            message: error.responseJSON.Message,

            type: 'error'

          })
        })

      }).catch(() => {
        /*     this.$message({
         type: 'info',
         message: 'Delete canceled'
         });*/
      })

    },
    DeleteLocation(locationid) {
      let context = this

      this.$confirm('This will permanently delete the location. Continue?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {

        loader.startLoader()

        service.DeleteLocation(locationid).then(function (response) {
          context.$router.app.$emit('invokePoolLoc')
          for (var i = 0; i < context.locations.length; i++) {

            if (context.locations[i].LocationId == locationid) {
              context.locations.splice(i, 1)
              i--
            }
          }

          // context.$message({
          //   type: 'success',
          //   message: 'Location deleted'
          // });
          context.$notify({

            title: 'Success',

            message: 'Location deleted',

            type: 'success'

          })
          loader.stopLoader()

        }, (error) => {

          loader.stopLoader()

          this.$notify({

            title: 'Error',

            message: error.responseJSON.Message,

            type: 'error'

          })
        })

      }).catch(() => {

      })

    },
    selectlocationCell(row) {
      if (this.selectedlocationId != row.LocationId) {
        this.getPools(row.LocationId)
        this.editLocation = false
        this.locationFlag = false
      }


      if (this.selectedlocationId == row.LocationId) {
        this.locationFlag = true;

      }
      if (!this.locationFlag) {

        this.currentLocationName = row.LocationName
        this.Timezoneselected = row.LocationOffset
      }

      this.selectedlocationId = row.LocationId


    },
    selectpoolCell(row) {

      if (this.selectedpoolId != row.PoolId) {
        this.editPool = false
      }
      this.currentPoolName = row.PoolName
      this.selectedpoolId = row.PoolId

    },

    selectpositionCell(row) {

      //this.currentPositionName = row.PositionName
      // this.selectedpoolId = row.PositionId

    },
    addLocation() {
      let context = this
      loader.startLoader()
      let model = {
        LocationName: this.locationName,
        LocationOffset: this.Timezone
      }
      service.AddLocation(model).then(function (response) {
        context.$router.app.$emit('invokePoolLoc')

        if (!context.locations) {
          context.locations = []
        } else {

          context.locations.push({
            LocationId: response.LocationId,
            LocationName: context.locationName,
            LocationOffset: context.Timezone
          })
          context.locationName = '';
          context.Timezone = '';
        }

        loader.stopLoader()

      }, (error) => {

        loader.stopLoader()

        this.$notify({

          title: 'Error',

          message: error.responseJSON.Message,

          type: 'error'

        })
      })

    },
    UpdateLocation(locationid, locationname, Timezone) {
      let context = this

      loader.startLoader()
      service.UpdateLocation({
        LocationId: locationid,
        LocationName: locationname,
        LocationOffset: Timezone
      }).then(function (response) {
        context.editLocation = false
        context.$router.app.$emit('invokePoolLoc')
        for (var i = 0; i < context.locations.length; i++) {

          if (context.locations[i].LocationId == locationid) {
            context.locations[i].LocationName = locationname
            context.locations[i].LocationOffset = Timezone
            context.currentLocationName = locationname,
              context.LocationOffset = Timezone
          }
        }

        loader.stopLoader()

      }, (error) => {

        loader.stopLoader()
        context.currentLocationName = locationname
        this.$notify({

          title: 'Error',

          message: error.responseJSON.Message,

          type: 'error'

        })
      })

    },

    handleCurrentChange(item) {

    },

  }

}



// WEBPACK FOOTER //
// ./src/pages/Administration/Positions.controller.js